const mocks = {
  'auth': { 'POST': { token: 'This-is-a-mocked-token' } },
  'user/me': { 'GET': { name: 'doggo', title: 'sir' } },
  'search/all' : {'GET': {'searchResults': [{'fileName' : 'Test1_' + Math.floor(Math.random() * 10) + '.pdf'}, {'fileName' : 'Test2_' + Math.floor(Math.random() * 10) + '.pdf'}]}}
}

const apiCall = ({url, method, ...args}) => new Promise((resolve, reject) => {
  setTimeout(() => {
    console.log('Sending request')
    try {
      resolve(mocks[url][method || 'GET'])
      //console.log(`Args '${args.data.username}'`)
      console.log(`Mocked '${url}' - ${method || 'GET'}`)
      console.log('response: ', mocks[url][method || 'GET'])
    } catch (err) {
      console.log('Error: ' + err)
      reject(new Error(err))
    }
  }, 1000)
})

export default apiCall
